import React from 'react';
import './Library.css';

function Library() {
    return (
        <div className='sectionPage'>
            <div className="terminology-table">

                <h2>General Terminology</h2>
                <table>
                    <thead>
                        <tr>
                            <th>Term</th>
                            <th>Definition</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td>Tang Soo Do</td><td>Name of the art we study</td></tr>
                        <tr><td>Moo Duk Kwan</td><td>Name of the style/organisation</td></tr>
                        <tr><td>Soo Bahk Do</td><td>Ancient name of the martial art in Korea</td></tr>
                        <tr><td>Kwan Jang Nim</td><td>Grandmaster/Chief Instructor</td></tr>
                        <tr><td>Sa Bom Nim</td><td>Qualified Instructor</td></tr>
                        <tr><td>Kyo Sa Nim</td><td>Assistant Instructor</td></tr>
                        <tr><td>Ban Jang</td><td>Prefect</td></tr>
                        <tr><td>Sun Beh</td><td>Senior Member</td></tr>
                        <tr><td>Hu Beh</td><td>Junior Member</td></tr>
                        <tr><td>Dan</td><td>Degree Holder</td></tr>
                        <tr><td>Gup</td><td>Grade Holder of colour Belt</td></tr>
                        <tr><td>Ko Dan Ja</td><td>Senior Dan Holder</td></tr>
                        <tr><td>You Dan Ja</td><td>Dan Holder</td></tr>
                        <tr><td>Kwan Won</td><td>Student member</td></tr>
                        <tr><td>Cho Bo Ja</td><td>Beginner</td></tr>
                        <tr><td>Do Jang</td><td>Training Hall</td></tr>
                        <tr><td>Do Balk</td><td>Training Uniform</td></tr>
                        <tr><td>Dee</td><td>Belt</td></tr>
                        <tr><td>Kuk Gi</td><td>National Flag</td></tr>
                        <tr><td>Kwan Gi</td><td>Organisational Flag</td></tr>
                        <tr><td>Shim Gung</td><td>Spiritual Power</td></tr>
                        <tr><td>Nae Gung</td><td>Internal Power</td></tr>
                        <tr><td>Weh Gung</td><td>External Power</td></tr>
                        <tr><td>Gi Cho</td><td>Basic</td></tr>
                        <tr><td>Hyung</td><td>Form</td></tr>
                        <tr><td>Deh Ryun</td><td>Sparring</td></tr>
                        <tr><td>Ho Sin Sul</td><td>Self-defence</td></tr>
                        <tr><td>Kyok Pa</td><td>Breaking Techniques</td></tr>
                        <tr><td>O Rin Jok</td><td>Right</td></tr>
                        <tr><td>Wen Jok</td><td>Left</td></tr>
                    </tbody>
                </table>

                <h2>Basic Stance (Gi Cho Ja Seh)</h2>
                <table>
                    <thead><tr><th>Term</th><th>Definition</th></tr></thead>
                    <tbody>
                        <tr><td>Joon Be Ja Seh</td><td>Ready Stance</td></tr>
                        <tr><td>Joon Gul Ja Seh</td><td>Front Stance</td></tr>
                        <tr><td>Hu Gul Ja Seh</td><td>Back Stance</td></tr>
                        <tr><td>Kee Mah Ja Seh</td><td>Horse Stance</td></tr>
                        <tr><td>Sa Goh Rip Ja Seh</td><td>Side Stance</td></tr>
                    </tbody>
                </table>

                <h2>Commands in Training</h2>
                <table>
                    <thead><tr><th>Term</th><th>Definition</th></tr></thead>
                    <tbody>
                        <tr><td>Cha Ryut</td><td>Attention</td></tr>
                        <tr><td>Kyung Yet</td><td>Bow</td></tr>
                        <tr><td>Joon Bee</td><td>Ready</td></tr>
                        <tr><td>Shi-Jak</td><td>Begin</td></tr>
                        <tr><td>Ku-Ryung</td><td>Count</td></tr>
                        <tr><td>Ku-Ryung E Mat Cho So</td><td>By the Count</td></tr>
                        <tr><td>Ku-Ryung Up Shi</td><td>Without Count</td></tr>
                        <tr><td>Ba-Ro</td><td>Return</td></tr>
                        <tr><td>Shio</td><td>Relax</td></tr>
                        <tr><td>Tora</td><td>Turn</td></tr>
                        <tr><td>Dwee Ro Tora</td><td>Turn to rear</td></tr>
                        <tr><td>Bal Cha Gi Joon Bee</td><td>Ready for Kick</td></tr>
                    </tbody>
                </table>

                <h2>Numbers</h2>
                <table>
                    <thead><tr><th>Counting</th><th>Listing</th></tr></thead>
                    <tbody>
                        <tr><td>Ha-Na</td><td>One</td></tr>
                        <tr><td>Tul</td><td>Two</td></tr>
                        <tr><td>Set</td><td>Three</td></tr>
                        <tr><td>Net</td><td>Four</td></tr>
                        <tr><td>Ta-Sot</td><td>Five</td></tr>
                        <tr><td>Yo-Sot</td><td>Six</td></tr>
                        <tr><td>Il-Gop</td><td>Seven</td></tr>
                        <tr><td>Yo-Dol</td><td>Eight</td></tr>
                        <tr><td>A-Hop</td><td>Nine</td></tr>
                        <tr><td>Yol</td><td>Ten</td></tr>
                        <tr><td>Yol Ha-Na</td><td>Eleven</td></tr>
                        <tr><td>Yol Tul</td><td>Twelve</td></tr>
                        <tr><td>Yol Set</td><td>Thirteen</td></tr>
                        <tr><td>Yol Net</td><td>Fourteen</td></tr>
                        <tr><td>Yol Ta-Sot</td><td>Fifteen</td></tr>
                        <tr><td>Yol Yo-Sot</td><td>Sixteen</td></tr>
                        <tr><td>Yol Il-Gop</td><td>Seventeen</td></tr>
                        <tr><td>Yol Yo-Dol</td><td>Eighteen</td></tr>
                        <tr><td>Yol A-Hop</td><td>Nineteen</td></tr>
                        <tr><td>Su Mul</td><td>Twenty</td></tr>
                    </tbody>
                </table>

                <h2>Technical Terms</h2>
                <table>
                    <tbody>
                        <tr><td>Jok Gi</td><td>Foot techniques</td></tr>
                        <tr><td>Mahk Kee</td><td>Block</td></tr>
                        <tr><td>Kong Kyuk</td><td>Attack</td></tr>
                        <tr><td>Ha Dan</td><td>Low section</td></tr>
                        <tr><td>Joong Dan</td><td>Middle section</td></tr>
                        <tr><td>Sang Dan</td><td>High section</td></tr>
                        <tr><td>Cha Gi</td><td>Kick</td></tr>
                        <tr><td>Ki Hap</td><td>Shout/Yell</td></tr>
                        <tr><td>Shi Sun</td><td>Focus of eyes</td></tr>
                        <tr><td>Jung Shim</td><td>Balance</td></tr>
                        <tr><td>Kwon Do</td><td>Knife fist</td></tr>
                        <tr><td>Kap Kwon</td><td>Back fist</td></tr>
                        <tr><td>Joong Kwon</td><td>Fore fist</td></tr>
                        <tr><td>Soo Do</td><td>Knife hand</td></tr>
                        <tr><td>Yuk Soo Do</td><td>Ridge hand</td></tr>
                        <tr><td>Kwan Soo</td><td>Spear hand</td></tr>
                        <tr><td>Jang Kwon</td><td>Heel of hand</td></tr>
                        <tr><td>Pal Koop</td><td>Elbow</td></tr>
                        <tr><td>Moo Roop</td><td>Knee</td></tr>
                    </tbody>
                </table>

                <h2>Commands in Starting and Closing Class</h2>
                <table>
                    <thead><tr><th>Term</th><th>Definition</th></tr></thead>
                    <tbody>
                        <tr><td>Cha Ryut</td><td>Attention</td></tr>
                        <tr><td>Kuk Gi Ba Rae</td><td>Bow to flag (if displayed)</td></tr>
                        <tr><td>Ba-Ro</td><td>Return</td></tr>
                        <tr><td>Chak Sut</td><td>Sit</td></tr>
                        <tr><td>Muk Nyum</td><td>Meditation</td></tr>
                        <tr><td>Kwan Jang Nim Kay Kyung Yet</td><td>Bow to the Grandmaster/Chief Instructor</td></tr>
                        <tr><td>Sa Bom Nim Kay Kyung Yet</td><td>Bow to the Instructor</td></tr>
                        <tr><td>Kyo Sa Nim Kay Kyung Yet</td><td>Bow to the Assistant Instructor</td></tr>
                        <tr><td>Sun Beh Nim Kay Kyung Yet</td><td>Bow to the Senior Member</td></tr>
                        <tr><td>Ban Jang Nim Kay Kyung Yet</td><td>Bow to the Prefect</td></tr>
                    </tbody>
                </table>

                <h2>Basic Movements (Hand)</h2>
                <table>
                    <thead><tr><th>Term</th><th>Definition</th></tr></thead>
                    <tbody>
                        <tr><td>Ha Dan Mahk Kee</td><td>Low Block</td></tr>
                        <tr><td>Sang Dan Mahk Kee</td><td>High Block</td></tr>
                        <tr><td>Ahneso Phakuro Mahk Kee</td><td>Inside to Outside Block</td></tr>
                        <tr><td>Phakeso Ahnuro Mahk Kee</td><td>Outside to Inside Block</td></tr>
                        <tr><td>Sang Soo Joong Dan Mahk Kee</td><td>Two Fist Middle Block</td></tr>
                        <tr><td>Sang Soo Ha Dan Mahk Kee</td><td>Two Fist (X) Low Block</td></tr>
                        <tr><td>Sang Soo Sang Dan Mahk Kee</td><td>Two Fist (X) High Block</td></tr>
                        <tr><td>Soo Do Ha Dan Mahk Kee</td><td>Low Section Knife Hand Block</td></tr>
                        <tr><td>Soo Do Joong Dan Mahk Kee</td><td>Middle Section Knife Hand Block</td></tr>
                        <tr><td>Soo Do Sang Dan Mahk Kee</td><td>High Section Knife Hand Block</td></tr>
                    </tbody>
                </table>

                <h2>Attacks</h2>
                <table>
                    <thead><tr><th>Term</th><th>Definition</th></tr></thead>
                    <tbody>
                        <tr><td>Joong Dan Kong Kyuk</td><td>Middle Punch</td></tr>
                        <tr><td>Sang Dan Kong Kyuk</td><td>High Punch</td></tr>
                        <tr><td>Hang Jin Kong Kyuk</td><td>Side Punch</td></tr>
                        <tr><td>Yuk Jin Kong Kyuk</td><td>Reverse Punch</td></tr>
                        <tr><td>Kwan Soo Kong Kyuk</td><td>Spear Hand Attack</td></tr>
                    </tbody>
                </table>

                <h2>Basic Movements (Leg)</h2>
                <table>
                    <thead><tr><th>Term</th><th>Definition</th></tr></thead>
                    <tbody>
                        <tr><td>Ahp Cha Gi</td><td>Front Kick</td></tr>
                        <tr><td>Ahp Podo Cha Gi</td><td>Front Snap Kick</td></tr>
                        <tr><td>Yup Cha Gi</td><td>Side Kick</td></tr>
                        <tr><td>Yup Podo Cha Gi</td><td>Side Snap Kick</td></tr>
                        <tr><td>Dull Ryo Cha Gi</td><td>Roundhouse Kick</td></tr>
                        <tr><td>Dwee Cha Gi</td><td>Back Kick</td></tr>
                        <tr><td>Dwee Dull Ryo Cha Gi</td><td>Spinning Back Kick</td></tr>
                        <tr><td>Dwee Dull Ryo Chi-Go Cha Gi</td><td>Back Spinning Chop Kick</td></tr>
                        <tr><td>Ahnese Phakuro Cha Gi</td><td>Circular Inside to Outside Kick</td></tr>
                        <tr><td>Phakeso Ahnuro Cha Gi</td><td>Circular Outside to Inside Kick</td></tr>
                        <tr><td>Phakeso Ahnuro Mah-Go Cha Gi</td><td>Circular Outside to Inside Block Kick</td></tr>
                        <tr><td>Yup Hu Ri Gi</td><td>Side Hook Kick</td></tr>
                        <tr><td>Bahl Yup Chit Pal Ki</td><td>Side Stamping Kick</td></tr>
                        <tr><td>Ahp Mee Ro Cha Gi</td><td>Front Pushing Kick</td></tr>
                        <tr><td>Moo Rup Cha Gi</td><td>Knee Kick</td></tr>
                        <tr><td>Moo Rup Dull Ryo Cha Gi</td><td>Knee Turning Roundhouse Kick</td></tr>
                        <tr><td>Peet Cha Gi</td><td>Diagonal Inside to Outside Snap Kick</td></tr>
                        <tr><td>E Dan</td><td>Jumping Kick</td></tr>
                    </tbody>
                </table>

                <h2>Forms (Hyung)</h2>
                <table>
                    <thead><tr><th>Term</th><th>Definition</th></tr></thead>
                    <tbody>
                        <tr><td>Gi Cho Hyung Il Bu</td><td>Basic Form One</td></tr>
                        <tr><td>Gi Cho Hyung Ee Bu</td><td>Basic Form Two</td></tr>
                        <tr><td>Gi Cho Hyung Sam Bu</td><td>Basic Form Three</td></tr>
                        <tr><td>Pyung Ahn Cho Dan</td><td>Pyung Ahn Form No. 1</td></tr>
                        <tr><td>Pyung Ahn Ee Dan</td><td>Pyung Ahn Form No. 2</td></tr>
                        <tr><td>Pyung Ahn Sam Dan</td><td>Pyung Ahn Form No. 3</td></tr>
                        <tr><td>Pyung Ahn Sah Dan</td><td>Pyung Ahn Form No. 4</td></tr>
                        <tr><td>Pyung Ahn Oh Dan</td><td>Pyung Ahn Form No. 5</td></tr>
                        <tr><td>Chil Sung Il Ro</td><td>Chil Sung Form No. 1</td></tr>
                        <tr><td>Chil Sung Ee Ro</td><td>Chil Sung Form No. 2</td></tr>
                        <tr><td>Chil Sung Sam Ro</td><td>Chil Sung Form No. 3</td></tr>
                        <tr><td>Chil Sung Sah Ro</td><td>Chil Sung Form No. 4</td></tr>
                        <tr><td>Chil Sung Oh Ro</td><td>Chil Sung Form No. 5</td></tr>
                        <tr><td>Chil Sung Yuk Ro</td><td>Chil Sung Form No. 6</td></tr>
                        <tr><td>Chil Sung Chil Ro</td><td>Chil Sung Form No. 7</td></tr>
                        <tr><td>Bassai Dai Hyung</td><td>Bassai Dai Form No. 1</td></tr>
                        <tr><td>Bassai Cho Hyung</td><td>Bassai Cho Form No. 2</td></tr>
                        <tr><td>Naihanji Cho Dan</td><td>Naihanji Form No. 1</td></tr>
                        <tr><td>Naihanji Ee Dan</td><td>Naihanji Form No. 2</td></tr>
                        <tr><td>Naihanji Sam Dan</td><td>Naihanji Form No. 3</td></tr>
                        <tr><td>Rohai Hyung</td><td>Crane Form</td></tr>
                        <tr><td>Jion Hyung</td><td>Temple Form</td></tr>
                        <tr><td>Kong Sang Koon Hyung</td><td>Big Temple Form</td></tr>
                        <tr><td>Wang Shu Hyung</td><td>King Form</td></tr>
                        <tr><td>O Sip Sa Bo Hyung</td><td>Fifty-four Steps Form</td></tr>
                        <tr><td>Ji On Hyung</td><td>Virtue and Compassion Form</td></tr>
                        <tr><td>Tae Kuk Kwon</td><td>Great Ultimate Fist</td></tr>
                        <tr><td>Yuk Ro Cho Dan</td><td>Six Paths Form No. 1</td></tr>
                        <tr><td>Yuk Ro Ee Dan</td><td>Six Paths Form No. 2</td></tr>
                        <tr><td>Yuk Ro Sam Dan</td><td>Six Paths Form No. 3</td></tr>
                        <tr><td>Yuk Ro Sah Dan</td><td>Six Paths Form No. 4</td></tr>
                        <tr><td>Yuk Ro Oh Dan</td><td>Six Paths Form No. 5</td></tr>
                        <tr><td>Yuk Ro Yuk Dan</td><td>Six Paths Form No. 6</td></tr>
                    </tbody>
                </table>


                <h2>Sparring (Dae Ryun)</h2>
                <table>
                    <thead><tr><th>Term</th><th>Definition</th></tr></thead>
                    <tbody>
                        <tr><td>Sam Soo Shik Dae Ryun</td><td>Three Step Sparring</td></tr>
                        <tr><td>Il Soo Shik Dae Ryun</td><td>One Step Sparring</td></tr>
                        <tr><td>Chwa Dae Ryun</td><td>Sitting Sparring</td></tr>
                        <tr><td>Dae Ryun Joon Bee</td><td>Ready for Sparring</td></tr>
                        <tr><td>Ja Yoo Dae Ryun</td><td>Free Sparring</td></tr>
                        <tr><td>Da Soo Dae Ryun</td><td>Sparring against two or more</td></tr>
                    </tbody>
                </table>

                <h2>Anatomy</h2>
                <table>
                    <thead><tr><th>Term</th><th>Definition</th></tr></thead>
                    <tbody>
                        <tr><td>Pal</td><td>Arm</td></tr>
                        <tr><td>Bahl</td><td>Foot</td></tr>
                        <tr><td>Chu Mok</td><td>Fist</td></tr>
                        <tr><td>Mok</td><td>Neck</td></tr>
                        <tr><td>Eema</td><td>Forehead</td></tr>
                        <tr><td>Dan Jun</td><td>Abdomen</td></tr>
                        <tr><td>In Joon</td><td>Between Nose and Mouth</td></tr>
                        <tr><td>Bal Deung</td><td>Instep</td></tr>
                        <tr><td>Bal Yup Koom Chi</td><td>Side Heel</td></tr>
                        <tr><td>Ban Jul Kwan Soo</td><td>Fore Knuckle Hand</td></tr>
                        <tr><td>Bal Ahp Buri Yup</td><td>Front outer side of heel</td></tr>
                        <tr><td>Bal Dwee Koom Chi Yup Ba Dak</td><td>Side of heel under foot</td></tr>
                        <tr><td>Hur Ri</td><td>Waist</td></tr>
                        <tr><td>Ta Ri</td><td>Leg</td></tr>
                        <tr><td>Soo</td><td>Hand</td></tr>
                        <tr><td>Tuck</td><td>Chin</td></tr>
                        <tr><td>Ko Whan</td><td>Groin</td></tr>
                        <tr><td>Myung Chi</td><td>Solar Plexus</td></tr>
                        <tr><td>Bal Ba Dak Mit</td><td>Palm Foot</td></tr>
                        <tr><td>Bal Dwee Koom Chi</td><td>Heel</td></tr>
                        <tr><td>Pal Mok</td><td>Wrist</td></tr>
                        <tr><td>Pal Koop</td><td>Elbow</td></tr>
                    </tbody>
                </table>

            </div>


        </div>
    );
}

export default Library;